<div class="carousel-container">
    <owl-carousel-o [options]="options">
      <ng-container *ngFor="let slide of slides">
        <ng-template carouselSlide [id]="slide.id">
          <img [src]="slide.img" alt="Carousel Image" class="img-fluid">
        </ng-template>
      </ng-container>
    </owl-carousel-o>
  </div>